"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var decorators_1 = require("../../decorator/decorators");
var config_1 = require("../../dic/config");
var opposition_repository_1 = require("../../repositories/opposition.repository");
var Filter_vue_1 = require("../filter/Filter.vue");
var vuex_class_1 = require("vuex-class");
var vue_property_decorator_1 = require("vue-property-decorator");
var layoutModule = vuex_class_1.namespace('layout');
var OppositionListComponent = (function (_super) {
    __extends(OppositionListComponent, _super);
    function OppositionListComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = false;
        _this.snackbar = false;
        _this.inProgress = false;
        _this.delimiters = [',', ';', ' '];
        return _this;
    }
    OppositionListComponent.prototype.onDialogOpen = function (value) {
        var _this = this;
        if (!value)
            return;
        this.oppositionRepository
            .getNotificationEmails()
            .then(function (notificationEmails) {
            _this.emails = notificationEmails.map(function (notificationEmail) { return notificationEmail.email; });
        });
    };
    OppositionListComponent.prototype.save = function () {
        var _this = this;
        if (this.inProgress) {
            return;
        }
        var notificationEmails = (this.emails || []).map(function (email) {
            return { email: email };
        });
        this.$validator.validateAll().then(function (result) {
            if (result === true) {
                _this.showLoadingItems();
                var callbackSuccess = function () {
                    _this.hideLoadingItems();
                    _this.dialog = false;
                    _this.globalError = null;
                    _this.emails = undefined;
                    _this.snackbar = true;
                };
                var callbackFail = function (response) {
                    _this.hideLoadingItems();
                    _this.snackbar = false;
                    switch (response.status) {
                        case 400:
                            (response.data || { errors: [] }).errors.forEach(function (error) {
                                _this.$validator.errors.add({
                                    field: error.property,
                                    msg: _this.$tc('errors.form.' + error.code)
                                });
                            });
                            break;
                        default:
                            _this.globalError = _this.$tc('errors.generic');
                            break;
                    }
                };
                _this.oppositionRepository
                    .replaceNotificationEmails(notificationEmails)
                    .then(callbackSuccess)
                    .catch(callbackFail);
            }
        });
    };
    OppositionListComponent.prototype.data = function () {
        return {
            emails: this.emails,
            globalError: this.globalError
        };
    };
    OppositionListComponent.prototype.showLoadingItems = function () {
        this.showProgressBar();
        this.inProgress = true;
    };
    OppositionListComponent.prototype.hideLoadingItems = function () {
        this.hideProgressBar();
        this.inProgress = false;
    };
    __decorate([
        decorators_1.Container(config_1.default.REPOSITORY_OPPOSITION),
        __metadata("design:type", opposition_repository_1.OppositionRepository)
    ], OppositionListComponent.prototype, "oppositionRepository", void 0);
    __decorate([
        layoutModule.Action('showProgressBar'),
        __metadata("design:type", Function)
    ], OppositionListComponent.prototype, "showProgressBar", void 0);
    __decorate([
        layoutModule.Action('hideProgressBar'),
        __metadata("design:type", Function)
    ], OppositionListComponent.prototype, "hideProgressBar", void 0);
    __decorate([
        vue_property_decorator_1.Watch('dialog'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], OppositionListComponent.prototype, "onDialogOpen", null);
    OppositionListComponent = __decorate([
        vue_class_component_1.default({ components: { FilterComponent: Filter_vue_1.default } })
    ], OppositionListComponent);
    return OppositionListComponent;
}(vue_1.default));
exports.default = OppositionListComponent;
